import React, { useRef } from "react";
import * as Icons from "react-feather";
import { useClickDetecter } from "lib/helpers";

export default function Modal(props) {
  const wrapperRef = useRef(null);
  useClickDetecter(wrapperRef, (flag) => {
    if (flag === false) {
      // props.handleClose();
    }
  });

  if (!props.show) {
    return null;
  }

  return (
    <>
      <div
        id="header-footer-modal-preview"
        className={`modal ${props.show ? "overflow-y-auto show" : ""}`}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-label={props.title || "پنجره گفتگو"}
        style={{
          marginTop: "0px",
          marginLeft: "0px",
          paddingLeft: "17px",
          zIndex: props.zIndex ?? 999,
        }}
      >
        <div className="modal-dialog modal-md" ref={wrapperRef}>
          <div className="modal-content">
            <div className="modal-header flex justify-between">
              <h2 className="font-medium text-base">{props.title}</h2>
              <button type="button" onClick={props.handleClose} aria-label="بستن">
                <Icons.X aria-hidden="true" />
              </button>
            </div>
            {props.children}
          </div>
        </div>
      </div>
    </>
  );
}
